const state = {
  patientID: 'f98a18a3-871a-4f41-9236-7673ba675047'
};

export default {
  state
};
